import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { BitmapTextFieldProperties } from "@lib/titan2/dist/game/control/properties/BitmapTextFieldProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Ellipse, Point } from "pixi.js";
import { ViewProperties } from "../../../utils/ViewProperties";
import { GameLang } from "../lang/GameLang";
import { GameBitMapFontStyle } from "../style/GameBitMapFontStyle";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
export class GameScatterPickCoconutProperties extends ViewProperties {
    constructor() {
        super();
        this.judderDistance = 20;
        this.judderAngle = 10;
        this.coconutSpineProperties = new SpineProperties(GameStyle.COCONUT, GameStyle.MODULE);
        this.ribbonPrizeTextProperties = [
            new TextFieldProperties(GameFontStyle.SCATTER_PICK_RIBBON_LOW, new Point(0, -64), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(256, 128)),
            new TextFieldProperties(GameFontStyle.SCATTER_PICK_RIBBON_MEDIUM, new Point(0, -64), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(256, 128)),
            new TextFieldProperties(GameFontStyle.SCATTER_PICK_RIBBON_HIGH, new Point(0, -64), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(256, 128)),
        ];
        this.miniTitleTextProperties = {
            text: new TextFieldProperties(GameFontStyle.SCATTER_PICK_LABEL_MINI, new Point(0, -128), GameLang.MINI, ControlConstants.CENTER, ControlConstants.CENTER, new Point(1024, 256)),
            image: new SpriteProperties(GameStyle.MINI_FANCY, SlingoStyle.MODULE, undefined, undefined, new Point(0.5, 0.5)),
            targetText: "mini",
        };
        this.minorTitleTextProperties = {
            text: new TextFieldProperties(GameFontStyle.SCATTER_PICK_LABEL_MINOR, new Point(0, -128), GameLang.MINOR, ControlConstants.CENTER, ControlConstants.CENTER, new Point(1024, 256)),
            image: new SpriteProperties(GameStyle.MINOR_FANCY, SlingoStyle.MODULE, undefined, undefined, new Point(0.5, 0.5)),
            targetText: "minor"
        };
        this.majorTitleTextProperties = {
            text: new TextFieldProperties(GameFontStyle.SCATTER_PICK_LABEL_MAJOR, new Point(0, -128), GameLang.MAJOR, ControlConstants.CENTER, ControlConstants.CENTER, new Point(1024, 256)),
            image: new SpriteProperties(GameStyle.MAJOR_FANCY, SlingoStyle.MODULE, undefined, undefined, new Point(0.5, 0.5)),
            targetText: "major",
        };
        this.jackpotMultiplierTextProperties = new BitmapTextFieldProperties(GameBitMapFontStyle.COUNTER, GameFontStyle.SCATTER_PICK_MULTIPLIER, new Point(0, -128), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(1024, 256));
        this.multiplierTextProperties = new BitmapTextFieldProperties(GameBitMapFontStyle.COUNTER, GameFontStyle.SCATTER_PICK_MULTIPLIER, new Point(0, -256), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(1024, 256));
        this.coconutSpineProperties.hitArea = new Ellipse(0, 0, 420, 450);
        this.multiplierTextProperties.scale.set(1.2);
    }
}
//# sourceMappingURL=GameScatterPickCoconutProperties.js.map